export default __webpack_public_path__ + "static/media/map.86c918ca.svg";